/*
 * File: 客户模块-工商信息字段映射表
 */
<template>
    <div class="tyc-map-report">
        <Paper class="tyc-map-report-paper">
            <list-layout-paper>
                <template slot="header-search">
                    <search-box
                        ref="searchBox"
                        :search-key="config.name"
                        :fields="config.searchFields"
                        @elementChange="searchChange"
                        @search-change="tycMapReportList.searchList"
                    />
                </template>
                <template slot="header-button">
                    <lotsButton
                        type="primary"
                        size="mini"
                        title="新增"
                        icon="el-icon-plus"
                        @click="handleAdd"
                    >新增</lotsButton>
                    <lotsButton
                        type="primary"
                        size="mini"
                        title="删除"
                        icon="el-icon-delete"
                        @click="handleDelete"
                    >删除</lotsButton>
                </template>
                <!-- 表格 -->
                <template v-slot:list="{ tableHeight }">
                    <edit-table-box
                        ref="editTableBox"
                        v-loading="tycMapReportList.tableLoading"
                        :key="rendertable"
                        :index="config.index"
                        :selection="config.selection"
                        :columns="config.columns"
                        :height="tableHeight"
                        :tableData="tycMapReportList.totalData"
                        :actions="config.actions || []"
                        :rowEdit="config.rowEdit"
                        :allowRowClick="!config.getAuthRole()"
                        :allowRowClickFunc="(row) => config.rowEnableEdit(row)"
                        :editDisableRule="(row) => !config.rowEnableEdit(row)"
                        @selection-change="tycMapReportList.handleSelectedRow"
                        @btn-event="handleActive"
                    >
                        <template #col-append="{item, row}">
                            <!-- 数据类型 -->
                            <span v-if="item.prop === 'tycChangeType'">{{ formatDictCodeToName(row[item.prop], dictDatas[item.optionsKey]) }}</span>
                            <!-- 映射字典值 -->
                            <span v-if="item.prop === 'dictCode'">{{ formatData(row, item.prop) }}</span>
                        </template>
                        <template #edit-col-append="{ item, row }">
                            <!-- 数据类型 -->
                            <el-select
                                v-if="item.prop === 'tycChangeType'"
                                v-model="row[item.prop]"
                                @change="(val) => handleChangeRow(row)"
                            >
                                <el-option
                                    v-for="it in handleDictionaryDataString(dictDatas[item.optionsKey])"
                                    :key="it.value"
                                    :label="it.label"
                                    :value="it.value"
                                />
                            </el-select>
                            <!-- 映射字典值 -->
                            <el-select
                                v-if="item.prop === 'dictCode'"
                                v-model="row[item.prop]"
                                @change="(val) => rendertable++"
                            >
                                <el-option
                                    v-for="it in row.dictCodeOptions"
                                    :key="it.value"
                                    :label="it.label"
                                    :value="it.value"
                                />
                            </el-select>
                        </template>
                    </edit-table-box>
                </template>
                <template slot="footer">
                    <lots-pagination
                        @size-change="tycMapReportList.sizeChange"
                        :current-page.sync="tycMapReportList.pageNo"
                        @current-change="tycMapReportList.pageChange"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="tycMapReportList.pageTotal">
                    </lots-pagination>
                </template>
            </list-layout-paper>
        </Paper>
    </div>
</template>

<script>
import { ref, reactive, onMounted, onActivated } from '@vue/composition-api';
import { Message } from 'element-ui';
import { formatDictCodeToName, handleDictionaryDataString } from '@/modules/mdm/utils.js';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import Paper from '@/components/core/Paper';
import listLayoutPaper from '@/components/lots/listLayout/Paper';
import searchBox from '@/components/lots/searchBox';
import lotsButton from '@/components/lots/lotsButton';
import editTableBox from '@/components/lots/editTableBox/Index';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import { getDictDataApi } from '@mdm/api/contractManage/contractListApi.js';
import { getTycMapReportList, saveTycMapReportList, deleteTycMapReportList } from '@mdm/api/customer/tycMapReport.js';
import { config as configStatic } from './config';

export default {
    name: 'tycMapReport',
    components: {
        Paper,
        listLayoutPaper,
        searchBox,
        lotsButton,
        editTableBox,
        lotsPagination
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const config = reactive(configStatic);
        const dictDatas = ref({});
        const rendertable = ref(1);

        class AccountListClass extends AdvanceListClass {
            beforeGetList(condition) {
                return searchDataFormat(condition);
            };
            afterGetList (res) {
                if (+res.code === 0) {
                    this.totalData.value = res.data.list.map((v) => ({
                        edit: -3,
                        allowEdit: true,
                        ...v,
                        tycChangeType: v.tycChangeType?.toString(),
                        dictCode: v.dictCode?.toString(),
                        dictCodeOptions: setDictCodeOptions(v)
                    }));
                    this.pageTotal.value = res.data.totalCount;
                }
                setupContext.root.$nextTick(() => {
                    setupContext.refs.editTableBox.$refs.moduleTable.doLayout(); // 解决表格错位
                });
            };
        }
        const tycMapReportList = new AccountListClass({
            Api: {
                listApi: getTycMapReportList, // 查询接口
                batchDeleteApi: deleteTycMapReportList // 删除接口
            }
        });
        // 查询参数转换
        const searchDataFormat = (condition = {}, params = {}) => {
            const newParams = { ...condition, ...params };
            Object.keys(newParams).forEach(v => {
                if (newParams[v] === undefined || newParams[v] === null || newParams[v] === '') {
                    delete newParams[v];
                }
            });
            return newParams;
        };
        // 查询条件发生变化时回调
        const searchChange = ({ column, searchData }) => {
            if (column.value === 'tycChangeType') {
                searchData.dictCode = '';
                const field = config.searchFields.find((v) => v.value === 'dictCode');
                if (searchData.tycChangeType) {
                    field.options = setDictCodeOptions(searchData);
                } else {
                    field.options = [];
                }
            }
        };
        // 映射字典值转换
        const formatData = (row, prop) => row.dictCodeOptions?.find((v) => v.value === row[prop])?.label;
        // 新增
        const handleAdd = () => {
            tycMapReportList.totalData.value.unshift({
                edit: 2,
                allowEdit: true
            });
            const timer = setTimeout(() => { // 解决表格错位
                setupContext.refs.editTableBox.$refs.moduleTable.doLayout();
            });
            timer && clearTimeout(timer);
        };
        // 表格内表单元素发生变化时回调
        const handleChangeRow = (row) => {
            row.dictCode = ''; // 映射字典值
            row.dictCodeOptions = setDictCodeOptions(row);
            rendertable.value++;
        };
        // 设置映射字典值的下拉项
        const setDictCodeOptions = (row) => {
            const dict = row.tycChangeType?.toString() === '1' ? 'SYS_SUPPLIER_NATURE' : 'SYS_TAXER_TYPE'; // 1-企业性质 2-纳税人类型
            return handleDictionaryDataString(dictDatas.value[dict]);
        };
        // 操作项
        const handleActive = (row, event) => {
            // 取消
            if (event === 'cancel') {
                rendertable.value++;
                tycMapReportList.handleSelectedRow([]);
            }
            // 保存
            if (event === 'save') {
                handleSave(row);
                tycMapReportList.handleSelectedRow([]);
            }
        };
        // 保存
        const handleSave = (row) => {
            saveTycMapReportList(row).then(res => {
                if (+res.code === 0) {
                    Message.success('保存成功');
                    tycMapReportList.getList();
                }
            }).finally(() => {});
        };
        // 删除
        const handleDelete = () => {
            const ids = tycMapReportList.selectedRows.value.map((v) => v.id);
            tycMapReportList.deleteRow(ids, false);
        };

        onActivated(() => {
            setupContext.refs.editTableBox.$refs.moduleTable.doLayout(); // 解决表格错位
        });
        onMounted(async () => {
            const { data } = await getDictDataApi({ dictCodes: 'TYC_CHANGE_TYPE,SYS_SUPPLIER_NATURE,SYS_TAXER_TYPE' });
            dictDatas.value = data || {};
            setupContext.refs.searchBox.submitSearch();
        });

        return {
            config,
            tycMapReportList,
            dictDatas,
            rendertable,
            searchChange,
            formatData,
            formatDictCodeToName,
            handleDictionaryDataString,
            handleAdd,
            handleChangeRow,
            handleActive,
            handleDelete
        };
    }
};
</script>

<style lang="less">
.tyc-map-report {
    width: 100%;
    .tyc-map-report-paper {
        height: 100%;
    }
    .header-button {
        margin-left: 10px;
    }
    .search-box .el-select .el-input input {
        height: 28px!important;
    }
    .list-layout-wrapper {
        height: 100%;
    }

    .list-layout .list-header .el-input {
        margin-left: 0;
    }
    .flex-layout .list-main {
        overflow: auto;
    }

    .flex-layout .table {
        overflow-y: auto;
    }

    .layout-content.tyc-map-report-paper {
        padding: 0px 0px 0px;
    }
    .edit-table-box .el-select {
        width: 100%;
    }
}
</style>
